import React from "react";
import { Typography } from "antd";

import { history } from "../../utils";

const { Title } = Typography;

const PageNotFound = () => {
  return (
    <div className="flex h-screen justify-center items-center">
      <div>
        <Title>Page Not Found</Title>
        <div
          onClick={() => history.navigate(-1)}
          className="cursor-pointer underline text-xl text-primary text-center"
        >
          Go back
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
